
import axios from "@/config/axios"


const state = {
  procesos: [],
  details: {},
  sujetos: [],
  documentos: [],
  documentosActuaciones: [],
  actuaciones: [],
  identificacion: [],
  visited: [],
  tab: 0,
  search: [],
  onlyActive: false,
  idProceso: 0,
  llaveProceso: 0,
  soloActivos: true,
  paginacionProcesos: {
    cantidadPaginas: 0,
  }, //procesos
  paginacionIdentificacion: {
    cantidadPaginas: 0,
  }, //procesos
  paginacionSujetos: {
    cantidadPaginas: 0,
  }, // sujetos
  paginacionActuaciones: {
    cantidadPaginas: 0,
  }, // actuaciones
  paginaActuaciones: 1, // actuaciones
  paginaSujetos: 1, // sujetos
  paginaProcesos: 1, // procesos
  paginaProcesos: 1, // identificacion
  status: {
    loading: false,
    error: false,
    statusCode: null,
    message: "",
  },
  radicacionModal: {
    show: false,
    consulted: false,
    message: "",
  },
  urlAyuda: "",
  notifier: {
    message: "",
    show: false,
    type: "info",
  },
  mensajes: {
    resultadosVacios:
      "La consulta no generó resultados, por favor revisar las opciones ingresadas e intentarlo nuevamente.",
    procesosRecientesActivos:
      "<hr class='my-2'><span class='font-weight-bold'>Nota:</span> esta activa la opción 'Procesos con Actuaciones Recientes', favor probar con 'Todos los procesos'.",
    encontradosVariosRegistros:
      "Se han encontrado varios registros con el mismo número de Radicación. Por favor consulte todos sus procesos.",
    encontradosVariosRegistrosRazonSocial:
      "Se han encontrado varios registros con el mismo nombre o razón social. Por favor consulte todos sus procesos.",
    encontradosVariosRegistrosMagistrados:
      "Se han encontrado varios registros con el mismo Juez/Magistrado y Clase de Proceso. Por favor consulte todos sus procesos.",
    documentoNoDisponible:
      "El documento solicitado no está disponible en este momento, por favor intente más tarde.",
    documentoNoGenerado:
      "El documento solicitado no pudo ser generado en este momento, por favor intente más tarde.",
  },
  inDetails: false,
};

const mutations = {
  setProcesos(state, procesos) {
    state.procesos = procesos;
  },
  clearProcesos(state) {
    state.procesos = [];
  },
  clearId(state) {
    state.search = [];
  },
  setDetails(state, details) {
    state.details = details;
  },
  addVisited(state, id) {
    state.visited.push(id);
  },
  addSearch(state, id) {
    state.search = id;
  },
  setDocumentos(state, documentos) {
    state.documentos = documentos;
  },
  setDocumentosActuaciones(state, documentosActuaciones) {
    state.documentosActuaciones = documentosActuaciones;
  },
  addOnlyActive(state, op) {
    state.onlyActive = op;
  },
  addIdProceso(state, number) {
    state.idProceso = number;
  },
  addLlaveProceso(state, number) {
    state.llaveProceso = number;
  },
  addSoloActivos(state, soloActivos) {
    state.soloActivos = soloActivos;
  },
  setSujetos(state, sujetos) {
    state.sujetos = sujetos;
  },
  setActuaciones(state, actuaciones) {
    state.actuaciones = actuaciones;
  },
  setPaginacion(state, item) {
    state[item.name] = item.value;
  },
  setStatus(state, status) {
    state.status = status;
  },
  setTab(state, tab) {
    state.tab = tab;
  },
  setPaginaActuaciones(state, paginaActuaciones) {
    state.paginaActuaciones = paginaActuaciones;
  },
  setPaginaProcesos(state, paginaProcesos) {
    state.paginaProcesos = paginaProcesos;
  },
  setPaginaIdentificacion(state, paginaIdentificacion) {
    state.paginaIdentificacion = paginaIdentificacion;
  },
  setPaginaSujetos(state, paginaSujetos) {
    state.paginaSujetos = paginaSujetos;
  },
  setUrlAyuda(state, url) {
    state.urlAyuda = url;
  },
  setNotifierShow(state, { show = false, message = "", type = "info" }) {
    state.notifier = {
      show,
      message,
      type,
    };
  },
  setInDetails(state, value) {
    state.inDetails = value;
  },
};
const actions = {
  setProcesos({ commit }, procesos) {
    commit("setProcesos", procesos);
  },
  setTab({ commit }, tab) {
    commit("setTab", tab || 0);
  },
  setPaginaProcesos({ commit }, paginaProcesos) {
    
    commit("setPaginaProcesos", paginaProcesos);
  },
  setPaginaIdentificacion({ commit }, paginaIdentificacion) {
    commit("setPaginaIdentificacion", paginaIdentificacion);
  },
  setPaginaSujetos({ commit }, paginaSujetos) {
    commit("setPaginaSujetos", paginaSujetos);
  },
  setPaginaActuaciones({ commit }, paginaActuaciones) {
    commit("setPaginaActuaciones", paginaActuaciones);
  },
  setStatus({ commit, dispatch }, status) {
    commit("setStatus", {
      loading: status.loading,
      error: status.error,
      message: status.message,
    });
    return {
      success: true,
    };
  },
  clearProcesos({ commit }) {
    commit("clearProcesos");
  },
  clearId({ commit }) {
    commit("clearId");
  },
  setUrlAyuda({ commit }, url) {
    commit("setUrlAyuda", url);
  },
  async numRadicacion({ commit, dispatch }, payload) {
    
    try {
      commit("setStatus", {
        loading: true,
        error: false,
        message: "",
      });
      
      let result = await axios
        .get(
          `/Procesos/Consulta/NumeroRadicacion?numero=${payload.id}&SoloActivos=${payload.soloActivos}&pagina=${state.paginaProcesos}`
        )
        .catch((err) => {
          if (err.response) {
            const error = new Error(err.response.data.Message);
            error.statusCode = err.response.data.StatusCode;
            throw error;
          }
          throw new Error(err);
        });

      let procesos = result.data.procesos;

      procesos.forEach((item) => {
        item.fechaProceso = item.fechaProceso
          ? item.fechaProceso.includes("T00:00:00")
            ? item.fechaProceso.replace("T00:00:00", "")
            : item.fechaProceso
          : "";
        item.fechaUltimaActuacion = item.fechaUltimaActuacion
          ? item.fechaUltimaActuacion.includes("T00:00:00")
            ? item.fechaUltimaActuacion.replace("T00:00:00", "")
            : item.fechaUltimaActuacion
          : "";
      });
      procesos.forEach((item) => {
        item.sujetosProcesales = item.sujetosProcesales
          ? item.sujetosProcesales.replace(/\|/g, "<br />")
          : "";
        item.sujetosProcesales = item.sujetosProcesales
          ? item.sujetosProcesales.replace(/\Demandante/g, "<b>Demandante</b>")
          : "";
        item.sujetosProcesales = item.sujetosProcesales
          ? item.sujetosProcesales.replace(/\Demandado/g, "<b>Demandado</b>")
          : "";
        item.sujetosProcesales = item.sujetosProcesales
          ? item.sujetosProcesales.replace(
              /\Departamento/g,
              "<b>Departamento</b>"
            )
          : "";
      });
      
      let paginacion = result.data.paginacion;
      commit("setProcesos", procesos);
      commit("setPaginacion", {
        name: "paginacionProcesos",
        value: paginacion,
      });
      commit(
        "addSearch",
        `NumeroRadicacion?numero=${payload.id}&SoloActivos=${payload.soloActivos}&pagina=${state.paginaProcesos}`
      );
      commit("addOnlyActive", payload.soloActivos);
      commit("setStatus", {
        loading: false,
        error: false,
        message: "",
      });

      // return result
    } catch (error) {
      dispatch("handleProcessError", error);
    }
  },

  async razonSocial(
    { state, commit, dispatch },
    { nombre, selectTipoPersona, numero, soloActivos }
  ) {
    try {
      commit("setStatus", {
        loading: true,
        error: false,
        message: "",
      });
      debugger
      let razonSocialAPIQry = `/Procesos/Consulta/NombreRazonSocial?nombre=${nombre}&tipoPersona=${selectTipoPersona}&SoloActivos=${soloActivos}&codificacionDespacho=${numero}&pagina=${state.paginaProcesos}`;
      /* razonSocialAPIQry = '/Procesos/Consulta/NombreRazonSocial?nombre=Ana Milena Moreno&tipoPersona=nat&SoloActivos=false
        &codificacionDespacho=&pagina=1' */
      let result = await axios.get(razonSocialAPIQry).catch((err) => {
        if (err.response) {
          const error = new Error(err.response.data.Message);
          error.statusCode = err.response.data.StatusCode;
          throw error;
        }
        throw new Error(err);
      });
      let razon = result.data.procesos;
      let paginacion = result.data.paginacion;

      razon.forEach((item) => {
        item.fechaProceso = item.fechaProceso
          ? item.fechaProceso.includes("T00:00:00")
            ? item.fechaProceso.replace("T00:00:00", "")
            : item.fechaProceso
          : "";
        item.fechaUltimaActuacion = item.fechaUltimaActuacion
          ? item.fechaUltimaActuacion.includes("T00:00:00")
            ? item.fechaUltimaActuacion.replace("T00:00:00", "")
            : item.fechaUltimaActuacion
          : "";
      });
      razon.forEach((item) => {
        console.log(item)
        // Si es nulo ignorar
        if (item.sujetosProcesales){
          item.sujetosProcesales = item.sujetosProcesales.replace(
            /\|/g,
            "<br />"
          );
          item.sujetosProcesales = item.sujetosProcesales.replace(
            /\Demandante/g,
            "<b>Demandante</b>"
          );
          item.sujetosProcesales = item.sujetosProcesales.replace(
            /\Demandado/g,
            "<b>Demandado</b>"
          );
          item.sujetosProcesales = item.sujetosProcesales.replace(
            /\Departamento/g,
            "<b>Departamento</b>"
          );
        }
      });
      commit("setProcesos", razon);
      commit("setPaginacion", {
        name: "paginacionProcesos",
        value: paginacion,
      });
      commit(
        "addSearch",
        `NombreRazonSocial?nombre=${nombre}&tipoPersona=${selectTipoPersona}&SoloActivos=${soloActivos}&codificacionDespacho=${numero}&pagina=${state.paginaProcesos}`
      );
      commit("setStatus", {
        loading: false,
        error: false,
        message: "",
      });
    } catch (error) {
      dispatch("handleProcessError", error);
    }
  },

  async juez(
    { commit, dispatch },
    { ponente, claseProceso, codificacionDespacho }
  ) {
    try {
      commit("setStatus", {
        loading: true,
        error: false,
        message: "",
      });
      let result = await axios
        .get(
          `/Procesos/Consulta/JuezClaseProceso?ponente=${ponente}&claseProceso=${claseProceso}&codificacionDespacho=${codificacionDespacho}`
        )
        .catch((err) => {
          if (err.response) {
            const error = new Error(err.response.data.Message);
            error.statusCode = err.response.data.StatusCode;
            throw error;
          }
          throw new Error(err);
        });
      let juez = result.data.procesos;

      juez.forEach((item) => {
        item.fechaProceso = item.fechaProceso
          ? item.fechaProceso.includes("T00:00:00")
            ? item.fechaProceso.replace("T00:00:00", "")
            : item.fechaProceso
          : "";
        item.fechaUltimaActuacion = item.fechaUltimaActuacion
          ? item.fechaUltimaActuacion.includes("T00:00:00")
            ? item.fechaUltimaActuacion.replace("T00:00:00", "")
            : item.fechaUltimaActuacion
          : "";
      });
      juez.forEach((item) => {
        item.sujetosProcesales = item.sujetosProcesales.replace(
          /\|/g,
          "<br />"
        );
        item.sujetosProcesales = item.sujetosProcesales.replace(
          /\Demandante/g,
          "<b>Demandante</b>"
        );
        item.sujetosProcesales = item.sujetosProcesales.replace(
          /\Demandado/g,
          "<b>Demandado</b>"
        );
        item.sujetosProcesales = item.sujetosProcesales.replace(
          /\Departamento/g,
          "<b>Departamento</b>"
        );
      });
      commit("setProcesos", juez);
      commit("setStatus", {
        loading: false,
        error: false,
        message: "",
      });
      commit(
        "addSearch",
        `JuezClaseProceso?ponente=${ponente}&claseProceso=${claseProceso}&codificacionDespacho=${codificacionDespacho}`
      );
    } catch (error) {
      dispatch("handleProcessError", error);
    }
  },

  async identificacion({ commit, rootState }, id) {
    try {
      commit("clearProcesos");
      commit("setStatus", {
        loading: true,
        error: false,
        message: "",
      });
      let result = await axios.get(
        // `/Procesos/Consulta/Identificacion?idSujeto=${id}`,
        `/Procesos/ConsultaPriv/Identificacion?idSujeto=${id}&SoloActivos=${false}&pagina=${state.paginaProcesos}`,
        {
          headers: {
            Authorization: `bearer ${rootState.auth.authUser.jwt}`,
          },
        }
      );
      let identificacion = result.data.procesos;
      let paginacion = result.data.paginacion;

      commit("setProcesos", identificacion);
      commit("setPaginacion", {
        name: "paginacionProcesos",
        value: paginacion,
      });
      // // commit('addSearch', id);
      commit("addSearch", `Identificacion?idSujeto=${id}`);
      commit("setStatus", {
        loading: false,
        error: false,
        message: "",
      });
    } catch (error) {
      let message = "An error has occurred";
      if (error.response) {
        message = error.response.data.message;
      } else if (error.request) {
        message =
          "No response received from the server. If the problem persists contact the site administrator (" +
          error.message +
          ")";
      } else {
        message = error.message;
      }
      commit("setStatus", {
        loading: false,
        error: true,
        message: message,
      });
    }
  },
  async details({ commit, dispatch }, item) {
    try {
      commit("setStatus", {
        loading: true,
        error: false,
        message: "",
      });
      let result = await axios
        .get(
          `/Proceso/Detalle/${item.id}`
        )
        .catch((err) => {
          if (err.response) {
            const error = new Error(err.response.data.Message);
            error.statusCode = err.response.data.StatusCode;
            throw error;
          }
          throw new Error(err);
        });
      let details = result.data;
      details.fechaProceso = details.fechaProceso
        ? details.fechaProceso.includes("T00:00:00")
          ? details.fechaProceso.replace("T00:00:00", "")
          : details.fechaProceso
        : "";

      commit("setDetails", details);
      commit("addVisited", item.id);
      commit("addIdProceso", item.id);
      commit("addLlaveProceso", details.llaveProceso);
      commit("setTab", item.tab || 0);
      commit("setStatus", {
        loading: false,
        error: false,
        message: "",
      });
      return {
        success: true,
      };
    } catch (error) {
      dispatch("handleDetailsError", error);
    }
  },

  async sujetos({ state, commit }, { id, nombre, tab }) {
    try {
      const idProceso = state.idProceso;
      commit("setStatus", {
        loading: true,
        error: false,
        message: "",
      });
      let result = await axios.get(
        `/Proceso/Sujetos/${idProceso}?${
          nombre ? `nombre=${nombre}&` : ""
        }pagina=${state.paginaSujetos}`
      );
      let sujetos = result.data.sujetos;
      let paginacion = result.data.paginacion;
      commit("setTab", tab || 0);
      commit("setSujetos", sujetos);
      commit("setPaginacion", {
        name: "paginacionSujetos",
        value: paginacion,
      });
      commit("setStatus", {
        loading: false,
        error: false,
        message: "",
      });
    } catch (error) {
      let message = "An error has occurred";
      if (error.response) {
        message = error.response.data.message;
      } else if (error.request) {
        message =
          "No response received from the server. If the problem persists contact the site administrator (" +
          error.message +
          ")";
      } else {
        message = error.message;
      }
      commit("setSujetos", []);
      commit("setPaginacion", {
        name: "paginacionSujetos",
        value: {},
      });
      commit("setStatus", {
        loading: false,
        error: true,
        message: message,
      });
    }
  },

  async documentos({ commit }, { id, tab }) {
    try {
      commit("setStatus", {
        loading: true,
        error: false,
        message: "",
      });
      let result = await axios.get(
        `/Proceso/Documentos/${id}`
      );
      let documentos = result.data;
      // // let paginacion = result.data.paginacion;
      commit("setTab", tab || 0);
      commit("setDocumentos", documentos);
      // // commit("setPaginacion", paginacion);
      commit("setStatus", {
        loading: false,
        error: false,
        message: "",
      });
    } catch (error) {
      let message = "An error has occurred";
      if (error.response) {
        message = error.response.data.message;
      } else if (error.request) {
        message =
          "No response received from the server. If the problem persists contact the site administrator (" +
          error.message +
          ")";
      } else {
        message = error.message;
      }
      commit("setStatus", {
        loading: false,
        error: true,
        message: message,
      });
    }
  },

  async documentosActuaciones({ commit }, gidActuacion) {
    try {
      
      commit("setStatus", {
        loading: true,
        error: false,
        message: "",
      });
      let result = await axios.get(
        `/Proceso/DocumentosActuacion/${gidActuacion}`        
      );
      let documentos = result.data;
      commit("setDocumentosActuaciones", documentos);
      commit("setStatus", {
        loading: false,
        error: false,
        message: "",
      });
    } catch (error) {
      let message = "An error has occurred";
      if (error.response) {
        message = error.response.data.message;
      } else if (error.request) {
        message =
          "No response received from the server. If the problem persists contact the site administrator (" +
          error.message +
          ")";
      } else {
        message = error.message;
      }
      commit("setStatus", {
        loading: false,
        error: true,
        message: message,
      });
    }
  },
 
  async detailsActuaciones({ commit }, { id, fechaIni, fechaFin, tab }) {
    try {
      commit("setStatus", {
        loading: true,
        error: false,
        message: "",
      });
      let result = await axios.get(
        `/Proceso/Actuaciones/${id}?${
          fechaIni ? `fechaIni=${fechaIni}&` : ""
        }${fechaFin ? `fechaFin=${fechaFin}&` : ""}pagina=${
          state.paginaActuaciones
        }`
      );
      let actuaciones = result.data.actuaciones;
      actuaciones.forEach((item) => {
        item.fechaActuacion = item.fechaActuacion
          ? item.fechaActuacion.includes("T00:00:00")
            ? item.fechaActuacion.replace("T00:00:00", "")
            : item.fechaActuacion
          : "";
        item.fechaRegistro = item.fechaRegistro
          ? item.fechaRegistro.includes("T00:00:00")
            ? item.fechaRegistro.replace("T00:00:00", "")
            : item.fechaRegistro
          : "";
        item.fechaInicial = item.fechaInicial
          ? item.fechaInicial.includes("T00:00:00")
            ? item.fechaInicial.replace("T00:00:00", "")
            : item.fechaInicial
          : "";
        item.fechaFinal = item.fechaFinal
          ? item.fechaFinal.includes("T00:00:00")
            ? item.fechaFinal.replace("T00:00:00", "")
            : item.fechaFinal
          : "";
      });
      let paginacion = result.data.paginacion;
      commit("setTab", tab || 0);
      commit("setPaginacion", {
        name: "paginacionActuaciones",
        value: paginacion,
      });
      commit("setActuaciones", actuaciones);
      commit("setStatus", {
        loading: false,
        error: false,
        message: "",
      });
    } catch (error) {
      let message = "An error has occurred";
      if (error.response) {
        message = error.response.data.message;
      } else if (error.request) {
        message =
          "No response received from the server. If the problem persists contact the site administrator (" +
          error.message +
          ")";
      } else {
        message = error.message;
      }
      commit("setActuaciones", []);
      commit("setPaginacion", {
        name: "paginacionActuaciones",
        value: {},
      });
      commit("setStatus", {
        loading: false,
        error: true,
        message: message,
      });
    }
  },
  // type puede ser: success, info, warning o error
  showNotifier({ commit }, { message = "", type = "info", error=null}) {
    // Si se especifica el error
    if (error){
      
      // Si el error contiene response
      if (error.response || error.message) {
        message = error?.response?.data?.Message || error.message;
        // Si el tipo es 500 mostrar error, de lo contrario un warning
        type =  (error?.response?.data?.StatusCode || error.statusCode) == 500 ? "error" : "warning"
      }else{
        message = error
        type =  "error"
      }
    }
    commit("setNotifierShow", {
      show: true,
      message,
      type,
    });
  },

  mostrarNotificacionRespuestaVacia({ state, dispatch }, soloActivos = false) {
    const message = soloActivos
      ? state.mensajes.resultadosVacios +
        state.mensajes.procesosRecientesActivos
      : state.mensajes.resultadosVacios;
    dispatch("showNotifier", {
      message,
    });
  },
  mostrarNotificacionError({ state, dispatch }) {
    let type = "info";
    if (state.status.statusCode === 500) {
      type = "error";
    }
    dispatch("showNotifier", {
      type,
      message: state.status.message,
    });
  },
  mostraNotificacionVariosRegistros(
    { state, dispatch },
    pagina = "radicacion"
  ) {
    let message = state.mensajes.encontradosVariosRegistros;

    if (pagina === "razon-social") {
      message = state.mensajes.encontradosVariosRegistrosRazonSocial;
    } else if (pagina === "Jueces") {
      message = state.mensajes.encontradosVariosRegistrosMagistrados;
    }

    dispatch("showNotifier", {
      message,
    });
  },
  notificarDocumentoNoDisponible({ state, dispatch }) {
    dispatch("showNotifier", {
      message: state.mensajes.documentoNoDisponible,
    });
  },
  handleError({ commit }, error) {
    let statusCode = null;
    const message = error.message;
    if (error.message.includes("mil registros")) {
      statusCode = 400;
    } else if (error.statusCode) {
      statusCode = error.statusCode;
    }

    commit("setStatus", {
      loading: false,
      error: true,
      message,
      statusCode,
    });
  },
  handleProcessError({ commit, dispatch }, error) {
    dispatch("handleError", error);
    commit("setProcesos", []);
    commit("setPaginacion", {
      name: "paginacionProcesos",
      value: {
        cantidadPaginas: 0,
      },
    });
  },
  handleDetailsError({ commit, dispatch }, error) {
    dispatch("handleError", error);
    commit("setDetails", []);
    commit("setPaginacion", {
      name: "paginacionProcesos",
      value: {
        cantidadPaginas: 0,
      },
    });
  },
  setInDetails({ commit }, value) {
    commit("setInDetails", value);
  },
};

const getters = {
  getProcesos(state) {
    return state.procesos ? state.procesos : [];
  },
  getDetails(state) {
    return state.details ? state.details : {};
  },
  getSujetos(state) {
    return state.sujetos ? state.sujetos : [];
  },
  getDocumentos(state) {
    return state.documentos ? state.documentos : [];
  },
  getDocumentosActuaciones(state) {
    return state.documentosActuaciones ? state.documentosActuaciones : [];
  },
  getActuaciones(state) {
    return state.actuaciones ? state.actuaciones : [];
  },
  getVisited(state) {
    return state.visited || [];
  },
  getIdProceso(state) {
    return state.idProceso;
  },
  getLlaveProceso(state) {
    return state.llaveProceso;
  },
  getSearch(state) {
    return state.search;
  },
  getOnlyActive(state) {
    return state.onlyActive;
  },
  getSoloActivos(state) {
    return state.soloActivos;
  },
  getStatus(state) {
    return state.status;
  },
  getTab(state) {
    return state.tab;
  },
  getPaginacionProcesos(state) {
    return state.paginacionProcesos || {};
  },
  getPaginacionIdentificacion(state) {
    return state.paginacionIdentificacion || {};
  },
  getPaginacionSujetos(state) {
    return state.paginacionSujetos || {};
  },
  getPaginacionActuaciones(state) {
    return state.paginacionActuaciones || {};
  },
  getPaginaActualActuaciones(state) {
    return state.paginacionActuaciones.pagina || 1;
  },
  getPaginaActualSujetos(state) {
    return state.paginacionSujetos.pagina || 1;
  },
  getPaginaActualProcesos(state) {
    return state.paginacionProcesos.pagina || 1;
  },
  getInDetails(state) {
    return state.inDetails || false;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
